import React, { useState,useEffect } from "react";
import { useQuery, useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import {useTranslation} from 'react-i18next';
import { callQueryapi } from "../../services/http/callapi";
import Loadingcomponent from "../../components/loader/loadingcomponent";
import ErrorMessage from "../../components/messaging/errormessage";
import CommonModalComponent from "../../components/common/common-modal";
import {useSelector, useDispatch} from "react-redux";
import {getItemOfSessionStorage} from "../../services/common/utils";
import { DISABLE_BALANCE_PAYMENT_METHOD, SELECTED_LANG, SHOW_EXCLUSIVE_FOR_BALANCE_OR_ADD_TO_BILL_PAYMENT_METHOD } from "../../services/common/Constants";
import {GTM_Pay, GTMScreenView, GTM_Begin_Checkout, GTM_Add_Payment_Info} from "../../../src/analytics/GoogleTagManager";
import ExclusiveModal from "../../components/common/exclusive-modal";
import {setPurchaseData, setPaymentType} from "../../reducer/actions";
import {CT_Events} from "../../../src/analytics/CTEvents";
import { groupByPaymentOptions } from "../../services/common/CommonUtils";
import PayOptionsList from "../../components/loader/skeletons/pay-options-list";

const SpecialDealsPrepaidPayment = () => {
  const {t} = useTranslation();
  const {state} = useLocation();
  const navigate = useNavigate();
  const dispatch= useDispatch();
  const [popupShow, setPopupShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
   const [isValidPaymentMethodsAvailable, setIsValidPaymentMethodsAvailable] =
   useState(false);
   const [disableContinue, setDisableContinue] = useState(false);
   const [offerListData, setOfferListData] = useState([]);
    const [enableapi,setenableapi] = useState(false);
  const selectedmsisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const childMsisdn = useSelector((state)=> state?.userdata?.value?.childMsisdn);
  const [toggleActive, setToggleActive] = useState(false);
  const language = getItemOfSessionStorage(SELECTED_LANG);
  const [toggleStatus, setToggleStatus] = useState(false);
  const [flag, setFlag] = useState(false);
  const [savecard, setSavecard] = useState(false);
  const { goSellElements, submit } = window?.goSell || {};
  const {data: offerData} = state;
  const [show, setShow] = useState(false);
  const [deeplinktext,setdeeplinktext] = useState('');
  const[disablepaymentoptions,setdisablepaymentoptions] = useState(false);
  const {CT_ScreenView, CT_Pay} = CT_Events();
    const toggleModal = () => {
      setPopupShow(!popupShow);
    };
    const toggleExModal = () => {
      setShow(!show);
    };
  
    const savecardclick=()=>{
      setSavecard(!savecard)
   }
   
    const offerslist = useQuery(
      [
        "",
        state?.psmItem?.method,
        JSON.parse(state?.psmItem?.sourceid),
        {},
        false
      ],
      {
        retry: false,
        onSuccess:(resp)=>{
          setOfferListData(resp)
          setenableapi(true);
          console.log("offerlist data  response",resp)
          if(state !== undefined && state?.data){
              let temp = resp?.data?.response?.AvailableOffers?.filter(obj => obj?.offercode === state?.offerCode);
              if(state !== undefined && state?.data && temp?.length > 0 ){
                state.data = temp?.[0];
              }
            
          }
        },
        onError:(err)=>{
        }
      }
    );

  const getPaymentOptions = useQuery(
    [
      "",
      "customerprofile/rjpaymentoptions",
      {
        purchasetype: "cvmoffer",
        points: "",
        price: state?.data?.amount,
        ordercatg: state?.data?.category,
        subcategory:state?.data?.subcategory,
      },
      {},
      false
    ],
    {
      retry: false,
      enabled:enableapi,
      onSuccess:(result)=>{

      },
      onError:(err)=>{

      }
    }
  );
  useEffect(()=>{
    setenableapi(true)
    try{
      GTMScreenView("SpecialDealsPrepaidPayment", selectedmsisdn, logintype)
    }catch{}
    try{
      CT_ScreenView();
    }catch{}
    try{
      GTM_Begin_Checkout(state?.data, "SpecialDeals_Postpaid")
    }catch{}
  }, [])

  const PaymentLink = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [
          {},
            "paymentgw/RnGetPaymentLink",
            {
              isfshareoffer: "",
              iscvmoffer: "Y",
              fulfilment_msisdn: (childMsisdn !== null && childMsisdn?.length ===8 && childMsisdn) ? "965"+childMsisdn: null,  
              paymentData: "",
              isapplepay: "F",
              isgooglepay: "F",
              offerid: state?.data?.offercode,
              offercategory: state?.data?.offertype,
              offersubcategory: state?.data?.offergroup,
              offerdesc: state?.data?.name,
              offerprice: state?.data?.amount,
              paymentchannel: selectedPaymentMethod?.channel, 
              discount_amount: "0",
              isupsell: "",
              total_amount: state?.data?.amount,
              currency: state?.data?.currency,
              action: "purchaseoffer",
              discoveruseroffermode: "roaming", 
              products: [{
                productid: state?.data?.offerid,
                productname: state?.data?.title,
                quantity: "1",
                unitofmeasure: "",
                grant_amount_kd: "",
                voice_grant_min: "",
                data_grant_mb: "",
                int_grant_min: "",
                item_price: state?.data?.amount,
                item_discount: "",
                total_price: state?.data?.amount,
                delilvery_address: ""
              }],
              cardid: selectedPaymentMethod?.cardid || "",
              tokenid: req ?? "", // token id
              savecard: savecard ? "Y" : "N"
            },
        ],
      }),
    {
      onSuccess: async (udata) => {
        const status = udata?.data?.status;
        const message = udata?.data?.message;
        try {
          if (status === "0") {
            dispatch(setPaymentType(selectedPaymentMethod?.channel))
            dispatch(setPurchaseData({data: state?.data, type: "SpecialDeals_Prepaid"}))
            setToggleStatus(false);
            try{
              setSavecard(false);
              GTM_Pay("SpecialDealsPrepaidPayment", selectedmsisdn, message, logintype, selectedPaymentMethod?.channel, "Success", "", state?.data?.amount, "", "" );
              // CT_Pay("", selectedPaymentMethod?.channel, state?.data?.amount, "", "Success");
            }catch{}
            if(udata?.data?.response?.paymenturl){
              setDisableContinue(true);
              window.location.href =
              udata?.data?.response?.paymenturl;
            }
          } else {
            try{
              setdisablepaymentoptions(false);
              setSavecard(false);
              GTM_Pay("SpecialDealsPrepaidPayment", selectedmsisdn, message, logintype, selectedPaymentMethod?.channel, "Failure", "", state?.data?.amount, "", "" );
              // CT_Pay("", selectedPaymentMethod?.channel, state?.data?.amount, "", "Failure");
            }catch{}
            setErrorMessage(message);
            setPopupShow(true);
          }
        } catch (e) {}
      },
      onError: (uerror) => {
        try{
          setdisablepaymentoptions(false);
          setSavecard(false);
          GTM_Pay("SpecialDealsPrepaidPayment", selectedmsisdn, "Api failed to load", logintype, selectedPaymentMethod?.channel, "Failure", "", state?.data?.amount, "", "" );
          // CT_Pay("", selectedPaymentMethod?.channel, state?.data?.amount, "", "Failure");
        }catch{}
      },
    }
  );

   //Toggle action to display the gosell payment block
   useEffect(()=>{
    if(selectedPaymentMethod?.channel == "CREDIT" &&
    selectedPaymentMethod?.optiontype == "CREDIT CARD"){ //"Another Credit Card"
      setToggleActive(true);
    }
    else{
      setToggleActive(false)
    }
   }, [selectedPaymentMethod])

  //Gosell payment 
  const onCallback = (response) => {
    PaymentLink.mutate(response?.id);
    setFlag(false);
  }

  useEffect(() => {
    // initialize card element
    if(toggleActive){
    goSellElements({
      containerID: "tap-card-elements",
      gateway: {
        callback: onCallback,
        publicKey: process.env.REACT_APP_TAP_PUBLIC_KEY,
        language: "en",
        supportedCurrencies: "all",
        supportedPaymentMethods: "all",
        notifications: "msg",
        labels: {
          cardNumber: t("Card_num"),
          expirationDate: "MM/YY",
          cvv: "CVV",
          cardHolder: t("Name_on_card"),
          actionButton: "Pay"
        },
        style: {
          base: {
            color: "#535353",
            lineHeight: "18px",
            fontFamily: "sans-serif",
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "rgba(0, 0, 0, 0.26)",
              fontSize: "15px"
            }
          },
          invalid: {
            color: "red",
            iconColor: "#fa755a "
          }
        }
      }
    })
  }
  }, [toggleActive])

  //save card toggle action
  const handleToggleButtonclick = () => {
    setToggleStatus(!toggleStatus);
  }

  const addToBillLink = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [
            {},
            'offers/activate',
            {
                offerid: state?.data?.offerid,
                action: 'ACCEPT',
                price: state?.data?.amount || '0',
                packprice: state?.data?.amount || '0',
             }
        ],
      }),
    {
      onSuccess: async (udata) => {
        const data = udata
        
        setDisableContinue(true);
        const status = udata?.data?.status;
        const infomsg = udata?.data?.infomsg;
        const message = udata?.data?.message;
        try {
            if (status === "0") {
               dispatch(setPaymentType(selectedPaymentMethod?.channel))
               dispatch(setPurchaseData({data: state?.data, type: "SpecialDeals_Prepaid"}))
                navigate("/transaction-status", {
                    state: { info_message: infomsg, message: message, status: udata?.data?.status, },
                });
                try{
                  GTM_Pay("SpecialDealsPrepaidPayment", selectedmsisdn, message, logintype, selectedPaymentMethod?.channel, "Success", "", state?.data?.amount, "", "" );
                  // CT_Pay("", selectedPaymentMethod?.channel, state?.data?.amount, "", "Success");
                }catch{}
            } else if (status === "-1") {
                const infomsg = udata?.data?.infomsg;
                const message = udata?.data?.message;
                navigate("/transaction-status", {
                    state: { info_message: infomsg, message: message, status: udata?.data?.status, },
                });
                try{
                  GTM_Pay("SpecialDealsPrepaidPayment", selectedmsisdn, message, logintype, selectedPaymentMethod?.channel, "Failure", "", state?.data?.amount, "", "" );
                  // CT_Pay("", selectedPaymentMethod?.channel, state?.data?.amount, "", "Failure");
                }catch{}
            }
        } catch (e) {
            //   setChecked(!checked);
        }

      },
      onError: (uerror) => {

      },
    }
  );


  const HandleContinueClick = () => {
    try{
      setdisablepaymentoptions(true);
      GTM_Add_Payment_Info(state?.data, "SpecialDeals_Postpaid", selectedPaymentMethod?.channel)
    }catch{}
    try{
      if ((selectedPaymentMethod?.optiontype.toUpperCase() === 'BALANCE' ||
      selectedPaymentMethod?.optiontype.toUpperCase() === 'ADD TO MY BILL') && SHOW_EXCLUSIVE_FOR_BALANCE_OR_ADD_TO_BILL_PAYMENT_METHOD) {
        setdisablepaymentoptions(false);
        setShow(true)
        setdeeplinktext('specialdeals');
        return false;
      }
     }catch{}

      if (selectedPaymentMethod?.channel === "KNET") {
        PaymentLink.mutate();
      }
      else if(selectedPaymentMethod?.channel == "CREDIT" &&
      selectedPaymentMethod?.optiontype.toUpperCase() == "CREDIT CARD"){
        setFlag(true);
        submit();
      }
      // else if (selectedPaymentMethod?.optiontype.toUpperCase() === "BALANCE" ||
      //   selectedPaymentMethod?.optiontype.toUpperCase() === "ADD TO MY BILL") 
      // {
      //     addToBillLink.mutate();
      // }
      else if(selectedPaymentMethod?.channel === "CREDIT"){
        PaymentLink.mutate();
      }
  };
  
  const handlePaymentMethodChange = (e, method) => {
    try{
    setSelectedPaymentMethod(method);
    setSavecard(false)
  }catch(e){}
  };

  const isPaymentMethodDisabled = (method) => {
    return (
      (method?.optiontype === "BALANCE" &&
      (Number(method?.totalbalance) < Number(offerData?.amount) ||
        Number(method?.totalbalance) < Number(offerData?.offerbaseprice)) || (method?.optiontype === "BALANCE" && DISABLE_BALANCE_PAYMENT_METHOD))
    );
  };

  const preferredPayOptions = getPaymentOptions?.data?.data?.response?.filter(item => item.category === 'PREFERRED') || [];
  const otherPayOptions = getPaymentOptions?.data?.data?.response?.filter(item => item.category === 'OTHER METHODS') || [];
  const payOptionsRes = [...preferredPayOptions, ...otherPayOptions];

  if (getPaymentOptions?.isSuccess && !selectedPaymentMethod) {  
    const balanceOption = getPaymentOptions?.data?.data?.response?.find(
      (option) => option?.optiontype === "BALANCE"
    );

    if (balanceOption != "" && balanceOption != undefined && balanceOption != ""
    && isPaymentMethodDisabled(balanceOption)) {
      if (getPaymentOptions?.data?.data?.response?.length > 1) {
        setIsValidPaymentMethodsAvailable(true);
        handlePaymentMethodChange(
          "",
          getPaymentOptions?.data?.data?.response[1]
        );
      }
    } else {
      setIsValidPaymentMethodsAvailable(true);
      handlePaymentMethodChange(
        "",
        getPaymentOptions?.data?.data?.response?.length > 0
          ? payOptionsRes[0] //getPaymentOptions?.data?.data?.response[0]
          : null
      );
    }
}

// if (
//   getPaymentOptions?.isLoading ||
//   getPaymentOptions?.isFetching
// ) {
//   return <Loadingcomponent message={"Loading"} />;
// }

if (
  getPaymentOptions?.error ||
  getPaymentOptions?.isError ||
  getPaymentOptions?.isLoadingError
) {
  return <ErrorMessage message={"Invalid"} />;
}

  return (
    <div className="pse_sm mt-4">
    <div className="pay-comp">
        <div className="sub-row">
          <div className="cont">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/details-icon.svg"}
              alt=""
              title=""
            />
            {state?.data?.name}
          </div>
        </div>
      <div className="total-comp">
        <div>{t('total')}</div>
        <div>
          {`${state?.data?.amount} ${t('kd')}`}
        </div>
      </div>
    </div>

    <div className="mt-5 mb-4">
      <h2 className="mb-2 page_title_v1">{t('PaymentMethod')}</h2>
      <p className="support_text mb-0">
        {t('select_payment_method')}
      </p>
    </div>

   
    <div className="radiobutton-comp mt-4">
      <div className="pay-cont">
        <div className="filter-comp mb-5">
            {
            getPaymentOptions?.isLoading || getPaymentOptions?.isFetching ? 
            <>
            {/* <Loadingcomponent message={"Loading"} /> */}
            <PayOptionsList />
            </> : (
                isValidPaymentMethodsAvailable && payOptionsRes && Object.entries(groupByPaymentOptions(payOptionsRes, 'category')).map(([cat, optionsData]) => {
                  return (
                    <>
                    <h6 className="primary_14 mt-5 cat-title" style={{textAlign: language=='ar' ? 'right' :'left'}}>{optionsData?.catLabel}</h6>
                    {
                      optionsData?.list?.map((method, index) => {
                        if(method?.channel == "CREDIT" && method?.optiontype == "CREDIT CARD"){
                          return(
                            <div className="filte-plane mt-4 white-bg borderradius15" key={index}>
                                <input type="radio"
                                       name="options"
                                       id={method?.title}
                                       checked={
                                        selectedPaymentMethod
                                          ? selectedPaymentMethod?.title === method?.title
                                          : index === 0
                                      }
                                       onChange={(e) => handlePaymentMethodChange(e, method)}
                                       disabled={isPaymentMethodDisabled(method) || disablepaymentoptions}
                                ></input>
                                <label htmlFor={method?.title}
                                       style={{
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                  className={
                                    (isPaymentMethodDisabled(method) || disablepaymentoptions)
                                    ? "payment-method-disabled"
                                    : ""
                                  }
                                       >
                                    <div>
                                        <img src={method?.iconpath} alt="" title="" />
                                        <span style={{fontWeight: 'bold'}}>{method?.title}</span>
                                    </div>
                        
                                    <div>
                                        {method?.balance || ""} {method?.currency || ""}
                                    </div>
                                   
                                    <div class="mb-3 msg" id="payment_ex_content"  
                                    style={{display: toggleActive? "block" : "none"}}>
                        
                                    <div id="tap-card-elements"></div>
                                    <p id='msg'></p>
                        <div class="d-flex justify-content-between mt-3" style={{border:"0px",fontSize:"16px"}}>
                        <div>{t("Save_card")}</div>
                        <div class="">
                        <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch"
                        checked={savecard}
                        id="flexSwitchCheckDefault" onChange={savecardclick}/>
                        </div>
                        </div>
                        </div>
                        </div>
                                </label>
                            </div>
                            )
                        }else{
                          let checkboxid = '';
                          let isChecked = (index === 0)
                          if(method?.cardid){
                            checkboxid = method?.cardid;
                            isChecked = selectedPaymentMethod?.cardid === method?.cardid
                          }else{
                            checkboxid = method?.title;
                            isChecked = selectedPaymentMethod?.title === method?.title
                          }
                        return (
                          <div className="filte-plane mt-4 white-bg borderradius15" key={index}>
                            <input
                              type="radio"
                              name="options"
                              id={checkboxid}
                              
                              checked={isChecked}
                              onChange={(e) => handlePaymentMethodChange(e, method)}
                              disabled={isPaymentMethodDisabled(method) || disablepaymentoptions}
                            ></input>
                            <label
                              htmlFor={checkboxid}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                              className={
                                (isPaymentMethodDisabled(method) || disablepaymentoptions)
                                  ? "payment-method-disabled"
                                  : ""
                              }
                            >
                              <div>
                                <img src={method?.iconpath} alt="" title="" />
                                <span style={{fontWeight: 'bold'}}>{method?.title}</span>
                              </div>
                        
                              <div>
                                {method?.balance || ""} {method?.currency ? t('kd') : ''}
                              </div>
                        
                              {
                                  method?.lblexpiry && method?.exp_month && method?.exp_month && method?.exp_year && (
                                    <div className="exp-date section_title_light"> {method?.lblexpiry} : {method?.exp_month}/{method?.exp_year}</div>
                                  )
                              }
                            </label>
                          </div>
                        );
                        }
                      })
                    }
                    </>
                  )
                })
              )
              }

            {/* Gosell payment */}
            {/* <div className="filter-comp mt-4"  style={{display: toggleActive? "block" : "none"}}>
                  <div id="tap-card-elements"> 
                   <p id='msg'></p>

                </div>
                <button style={{backgroundColor: toggleStatus? "#ED1C24": "#E0E0E0", width: '120px', borderRadius: "30px", border: "none", height: "40px" }} onClick={handleToggleButtonclick}>click me</button>                  
              </div> */}

          {!isValidPaymentMethodsAvailable && (!getPaymentOptions?.isLoading && !getPaymentOptions?.isFetching)  && (
            <div>
              <p>{t('no_valid_payment_methods')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
    <section className="fixed_footer">
        <div className="fixed_footer_container">
          <button
            className={(PaymentLink?.isLoading || addToBillLink?.isLoading || flag) ? "custom_btn custom_btn_secondary btn_block" :"custom_btn custom_btn_primary btn_block"}
            onClick={ (PaymentLink?.isLoading || addToBillLink?.isLoading) ? "" : HandleContinueClick}
            disabled={!isValidPaymentMethodsAvailable || disableContinue}>
              {
                (PaymentLink?.isLoading || addToBillLink?.isLoading || flag)? <Loadingcomponent></Loadingcomponent> :t("continue")
             }
           
          </button>
        </div>
      </section>
      <CommonModalComponent
        title={errorMessage}
        description=""
        cancelText="Ok"
        show={popupShow}
        hideSubmitButton
        submitText=""
        toggleModal={() => {
          toggleModal();
        }}
        submit={() => {}}
      />
      <ExclusiveModal show={show} toggleModal={toggleExModal} 
        deeplinktext={deeplinktext}/>
  </div>
  );
};
export default SpecialDealsPrepaidPayment;
